import { v4 as uuidv4 } from 'uuid';
import { safeLocalStorage } from 'utils/storage';

export const BROWSER_ID = 'browserId';

export function getBrowserId() {
  let browserId = safeLocalStorage.getItem(BROWSER_ID);

  if (!browserId) {
    browserId = uuidv4();
    safeLocalStorage.setItem(BROWSER_ID, browserId);
  }

  return browserId;
}
